"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8036],{

/***/ 98036:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(44012);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26628);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_4__);






// @ts-ignore
var Dropdown = next_dynamic__WEBPACK_IMPORTED_MODULE_4___default()(function() {
    return __webpack_require__.e(/* import() */ 3154).then(__webpack_require__.bind(__webpack_require__, 53154));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(53154)
            ];
        }
    }
});
function DropdownLanguage() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    var locale = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return state.locale;
    });
    var languages = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return state.locale.list;
    });
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(router.locale === "catchAll" ? locale.code : router.locale), newLocal = ref[0], setNewLocal = ref[1];
    if (!languages) {
        return null;
    }
    var handleRoute = function(locale) {
        setNewLocal(function() {
            return locale;
        });
        return router.push(router.asPath !== "/" ? router.asPath : "", router.asPath !== "/" ? router.asPath : "", {
            locale: locale.code
        });
    };
    var title = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        id: "topBar.language",
        defaultMessage: "English"
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Dropdown, {
        withIcons: true,
        forWhat: "language",
        title: title,
        locale: locale,
        newLocal: newLocal,
        items: languages,
        onClick: handleRoute
    });
}
/* harmony default export */ __webpack_exports__["default"] = (DropdownLanguage);


/***/ })

}]);